/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Card_AddedInputs */

const en_directory_card_added = /** @type {(inputs: Directory_Card_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.date}`)
};

const zh_directory_card_added = /** @type {(inputs: Directory_Card_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`收录于 ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Added {date}" |
*
* @param {Directory_Card_AddedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_added = /** @type {((inputs: Directory_Card_AddedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_AddedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_added(inputs)
	return zh_directory_card_added(inputs)
});
export { directory_card_added as "directory.card.added" }